import { Utils } from './../../utils';
import { Component, OnInit, Input, OnDestroy, ElementRef, Output, EventEmitter } from '@angular/core';

export interface PtVideoTrigger
{
  type: string,
  playerId: string,
  feature: string,
  triggerType: string,
  times: number[]
}

@Component({
  selector: 'wistia-video',
  template: require('./wistia-video.component.html'),
  styles: [require('./wistia-video.component.css')]
})
export class WistiaVideoComponent implements OnInit, OnDestroy {
  static jsonpScriptIdPrefix = 'wistia_jsonp_';

  static ptVideoTriggers: PtVideoTrigger[] = 
  [
    {
      type: "wistia",
      playerId: "egbnksvisn",
      feature: "1548-zy6vmHSnOHlGS4RkyhzCrtKh1mdH38esYftD2UzX",
      triggerType: "cue",
      times: [120]
    }
  ];

  get jsonpScriptId()
  {
    return WistiaVideoComponent.jsonpScriptIdPrefix + this.videoId;
  }

  @Input()
  autoplay = false;

  @Input()
  set videoId(value: string | undefined)
  {
    if(value == this.videoId)
      return;
      
    this.removeVideoJsonp();
    this._videoId = value;
    this.loadVideoJsonp();
    this.checkReadyInterval = setInterval(() => 
    {
      if(this.isReady)
      {
        this.onReady();
        if(this.checkReadyInterval) this.checkReadyInterval = null;
      }
    }, 50) as any as number;
  }

  @Output()
  ready = new EventEmitter<void>();

  @Output()
  ended = new EventEmitter<WistiaVideoComponent>();

  get videoId(): string | undefined
  {
    return this._videoId;
  }

  get videoElement() : HTMLVideoElement | null
  {
    return this.elementRef.nativeElement.querySelector('video');
  }

  get bigPlayButton(): HTMLButtonElement | null
  {
    return this.elementRef.nativeElement.querySelector('button.w-big-play-button');
  }

  get isReady()
  {
    return this.videoElement != null;
  }

  private _videoId?: string;

  private set checkReadyInterval(value: number | null)
  {
    if(this.checkReadyInterval)
      clearInterval(this.checkReadyInterval)

    this._checkReadyInterval = value;
  }

  private get checkReadyInterval(): number | null
  {
    return this._checkReadyInterval;
  }

  private _checkReadyInterval: number | null = null;

  jsonpLoaded = false;

  constructor(private elementRef: ElementRef) { (window as any).wv = this; }

  ngOnInit() {
  }

  ngOnDestroy () 
  {
    this.removeVideoJsonp();
  }

  private onReady()
  {
    this.ready.emit();
    if(this.autoplay) this.play();
    if(this.videoElement) this.videoElement.onended = () => this.ended.emit(this);
  }

  play()
  {
    Utils.waitFor(() => this.bigPlayButton != null, () => 
    {
      if(this.bigPlayButton) 
        this.bigPlayButton.click()
    });
    Utils.waitFor(() => this.videoElement != null, () => 
    {
      if(this.videoElement) 
        this.videoElement.play();
    });
  }

  pause()
  {
    if(this.videoElement) this.videoElement.pause();
  }

  private removeVideoJsonp()
  {
    if(this.videoId == null)
      return;

    this.jsonpLoaded = false;
    const jsonpScript = document.getElementById(this.jsonpScriptId);

    if(jsonpScript == null)
      return;

    if(document.head != null) document.head.removeChild(jsonpScript);
  }

  private loadVideoJsonp()
  {
    if(this.videoId == null)
      return;
    
    if(document.getElementById(this.jsonpScriptId) != null) // possibly we need to fully check if script is loaded
    {
      setTimeout(() => this.jsonpLoaded = true, 50);
      return;
    }

    this.jsonpLoaded = false;
    const script = document.createElement('script');
    script.id = this.jsonpScriptId;
    script.onload = () => {
      this.jsonpLoaded = true;
      const ptVideoTriggers = (window as any).PTVideoTriggers;
      if(ptVideoTriggers != null)
      {
        const trigger = WistiaVideoComponent.ptVideoTriggers.find(t => t.playerId == this.videoId);
        if(trigger != null)
        {
          ptVideoTriggers.listen(trigger);
        }
      }
    };
    script.src = 'https://fast.wistia.com/embed/medias/'+ this.videoId + '.jsonp';

    if(document.head != null) document.head.appendChild(script);
  }

}
